import supHttps from '../init/supHttps';

//SUP-INFO-01 : Get all the data required for support
export async function supInfoFun(type, phoneNumber, limit, offset) {
    const sup = await supHttps.get(`/support/search/${type}/${phoneNumber}?limit=${limit}&offset=${offset}`);
    return sup;
}

//SUP-INFO-02 : Create Ticket
export async function createTicketFun(type, data) {
    const sup = await supHttps.post(`/support/ticket/create/${type}`, data);
    return sup;
}

//SUP-INFO-03 : Edit ticket
export async function editTicket(type, ticketId, data) {
    const result = await supHttps.patch(`/support/ticket/edit/${type}/${ticketId}`, data);
    return result;
}

//SUP-INFO-04 : Get all the tickets
export async function ticketsInfo(type, status) {
    const tickets = await supHttps.get(`/support/tickets/${type}?status=${status}&limit=10&offset=0`);
    return tickets;
}

//SUP-INFO-05 : Get ticket details
export async function getTicketById(id) {
    const tickets = await supHttps.get(`/support/ticket/details/${id}`);
    return tickets;
}

//SUP-INFO-06 : Get support user account info
export async function getSupportUser() {
    const userData = await supHttps.get(`/support/account/info`);
    return userData;
}

//SUP-INFO-07 Abandon cart list
export async function getSupAbandonList(type, status, limit, offset) {
    const result = await supHttps.get(`/support/abandon/list/${type}?status=${status}&limit=${limit}&offset=${offset}`);
    return result;
}

//SUP-INFO-11 : Tickets Count
export async function ticketsCountFun(type) {
    const result = await supHttps.get(`/support/count/tickets/${type}`);
    return result;
}

//SUP-INFO-12 : Search Count
export async function searchCountFun(type, phoneNumber) {
    const result = await supHttps.get(`/support/count/search/${type}/${phoneNumber}`);
    return result;
}

//SUP-INFO-13 : Send email and message to customer
export async function sendEmail(type, bookingId) {
    const result = await supHttps.get(`/support/send/details/${type}/${bookingId}`);
    return result;
}

//SUP-INFO-14 : Comment on a ticket
export async function commentOnTicket(type, ticketId, data) {
    const result = await supHttps.patch(`/support/comment/ticket/${type}/${ticketId}`, data);
    return result;
}
